/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface StartChargePointTransaction$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected charge point
 */
  chargePointUid: string;

/**
 * The uid of the selected connector or 0 for requesting general chargepoint
 */
  connectorUid: string;

/**
 * The ID of the tag to use
 */
  tagId: string;
}

export function startChargePointTransaction(http: HttpClient, rootUrl: string, params: StartChargePointTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, startChargePointTransaction.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('chargePointUid', params.chargePointUid, {});
    rb.path('connectorUid', params.connectorUid, {});
    rb.query('tagId', params.tagId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

startChargePointTransaction.PATH = '/stations/{uid}/drive/chargepoints/{chargePointUid}/start/{connectorUid}';
